import React from "react";
import { IoShareOutline } from "react-icons/io5";
import { Navigate, useLocation, useNavigate } from "react-router-dom";

// Components
import {
  AqmarineButton,
  BlueButton,
  OrangeButton,
  YellowButton,
} from "../components/Buttons";
import MainView from "../components/MainView";

// Assets
import trophyImg from "../assets/core/img/trophy.png";
import welldoneImg from "../assets/core/img/welldone.png";

export default function GameEnd() {
  const location = useLocation();
  const navigate = useNavigate();

  const { game, score } = location.state || {};

  if (!game) {
    return <Navigate to="/games" replace />;
  }

  return (
    <MainView>
      <div className="my-7 px-[5vw] 2xl:px-[15vw]">
        <div className="flex flex-col items-center justify-center">
          <div className="mx-auto w-full xl:max-w-6xl 2xl:max-w-[1440px] flex sm:justify-end">
            <div className="border-2 border-black bg-retro-grey w-full sm:h-20 sm:w-[calc(100%_-_48px)]">
              <div className="relative flex items-center justify-between py-2 px-2 sm:justify-between sm:py-0 sm:pr-4 sm:pl-16 h-full w-full">
                <div className="sm:absolute left-0 sm:top-auto sm:-left-12 bg-retro-medal bg-cover rounded-full h-12 w-12 sm:h-24 sm:w-24 flex items-center justify-center">
                  <p className="font-retro-rounded font-medium text-[180%] sm:text-[280%]">
                    {score.toLocaleString([], {
                      minimumIntegerDigits: 2,
                      useGrouping: false,
                    })}
                  </p>
                </div>

                <div className="hidden sm:block">
                  <p className="font-retro-sabo uppercase text-center leading-none text-xl sm:text-3xl">
                    Your Score
                  </p>
                </div>

                <div className="">
                  <BlueButton
                    onClick={() => {
                      console.log("Share");
                    }}
                  >
                    <IoShareOutline size={24} className="mr-2" />
                    Share
                  </BlueButton>
                </div>
              </div>
            </div>
          </div>

          <div className="mx-auto mt-5 w-full xl:max-w-6xl 2xl:max-w-[1440px] flex sm:justify-end">
            <div className="w-full">
              <div className="flex flex-col sm:flex-row items-center py-2 px-2 sm:justify-around sm:py-0 h-full w-full">
                <div className="w-full sm:w-[40%] mb-3 last:mb-0 sm:mb-0">
                  <AqmarineButton
                    onClick={() => {
                      navigate(`/g/${game.game_id}`, {
                        state: { game },
                        replace: true,
                      });
                    }}
                  >
                    Play Again
                  </AqmarineButton>
                </div>

                <div className="w-full sm:w-[40%] mb-3 last:mb-0 sm:mb-0">
                  <OrangeButton
                    onClick={() => {
                      navigate("/games", { replace: true });
                    }}
                  >
                    Home
                  </OrangeButton>
                </div>
              </div>
            </div>
          </div>

          <div className="mx-auto my-14 w-full xl:max-w-6xl 2xl:max-w-[1440px] flex sm:justify-end">
            <div className="w-full">
              <div className="flex flex-col sm:flex-row items-center py-2 px-2 sm:justify-center sm:py-0 h-full w-full">
                <div className="h-20 lg:h-24 w-full sm:w-fit mb-3 last:mb-0 sm:mb-0">
                  <img src={trophyImg} alt="" className="h-full mx-auto" />
                </div>

                <div className="h-20 lg:h-24 w-full sm:w-fit mb-3 last:mb-0 sm:mb-0">
                  <img src={welldoneImg} alt="" className="h-full mx-auto" />
                </div>
              </div>
            </div>
          </div>

          <div className="mx-auto mb-5 w-full xl:max-w-6xl 2xl:max-w-[1440px] flex sm:justify-end">
            <div className="w-full">
              <div className="flex flex-col sm:flex-row items-center py-2 px-2 sm:justify-around sm:py-0 h-full w-full">
                <div className="w-full sm:w-[40%] mb-3 last:mb-0 sm:mb-0">
                  <YellowButton
                    onClick={() => {
                      navigate(`/g/${game.game_id}/leaderboard`, {
                        state: { game },
                        replace: true,
                      });
                    }}
                  >
                    Leaderboard
                  </YellowButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MainView>
  );
}
